import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { getGroupAdminInfo } from "../api/group";
import { putSetImageGroup } from "../api/signin";
import groupPic from "../assets/image/groupPic.png";
import AddPhotoIcon from "../assets/SVG/addPhotoIcon";
import ReplacementIcon from "../assets/SVG/replacementIcon";
import UploadProfile from "./profile/uploadProfile";
import ReplacementGroupLeader from "./replacementGroupLeader";

export default function GroupInfo({ color, lodgment, id, groupId, ownerId }) {
  const [dataAdmin, setDataAdmin] = useState();
  const [image, setImage] = useState();
  const [openUploader, setOpenUploader] = useState();
  const [hover, setHover] = useState();

  const data = [
    { label: "نام و نام خانوادگی", value: dataAdmin?.name },
    { label: "کد ملی", value: dataAdmin?.nid },
    { label: "نام پدر", value: dataAdmin?.fatherName },
    { label: "شماره تلفن ثابت", value: dataAdmin?.tel },
    { label: "تاریخ تولد", value: dataAdmin?.birthDay },
    { label: "شماره تلفن همراه", value: dataAdmin?.phone },
    {
      label: "دانشگاه",
      value: `${dataAdmin?.university} / ${dataAdmin?.universityYear}`,
    },
    {
      label: "تاریخ فعال سازی نرم افزار",
      value: dataAdmin?.createdAt.split(" ", 1),
    },
    { label: "رشته", value: dataAdmin?.field },
    { label: "کدمعرف", value: dataAdmin?.groupCode },
  ];
  const [showReplaceModal, setShowReplaceModal] = useState();
  useEffect(() => {
    getGroupAdminInfo(ownerId)
      .then((x) => {
        setDataAdmin(x);
        setImage(x.pic);
      })
      .catch((z) => console.log(z));
  }, []);
  const onChangeValueImage = (event) => {
    const file = event.target.files[0];
    let url = window?.URL?.createObjectURL(file);

    setImage({ file: file, url: url });
    setOpenUploader(null);
    if (image) {
      let formDataImage = new FormData();
      formDataImage.append("file", file);
      putSetImageGroup(formDataImage)
        .then(() => console.log("shod"))
        .catch((err) => console.log("nashod"));
      // console.log(image);
    }
  };
  return (
    <>
      <UploadProfile
        onChangeValueImage={onChangeValueImage}
        anchorEl={openUploader}
        setAnchorEl={setOpenUploader}
      />
      <ReplacementGroupLeader
        groupName={dataAdmin?.groupName}
        setDataAdmin={setDataAdmin}
        userId={id}
        groupId={groupId}
        show={showReplaceModal}
        setShow={setShowReplaceModal}
      />
      <Box
        border="solid 1px #6C8C97"
        p="20px"
        mt="30px"
        borderRadius="13px"
        width="100%"
      >
        <Box justifyContent="space-between" display={"flex"}>
          <Box alignItems="center" display={"flex"}>
            <Box
              position="relative"
              // onClick={(e) => setOpenUploader(e.currentTarget)}
            >
              <img
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  border: " 1px solid rgba(18, 110, 131, 0.81)",
                  // border: " 1px solid rgba(18, 110, 131, 0.81)",
                }}
                // onMouseEnter={() => {
                //   setHover(true);
                // }}
                className="imageHover"
                src={image || groupPic}
              />
              {hover && (
                <Box
                  onMouseLeave={() => {
                    setHover(false);
                  }}
                  width="100px"
                  borderRadius="50%"
                  position="absolute"
                  height="100px"
                  bgcolor="#00000090"
                  display="grid"
                  justifyItems="center"
                  alignContent="center"
                  sx={{ cursor: "pointer", top: "2px" }}
                >
                  <AddPhotoIcon />
                  <Typography fontSize={"13px"} color="white" mt="10px">
                    {"ویرایش عکس"}
                  </Typography>
                </Box>
              )}
            </Box>
            <Box mr="10px">
              <Typography
                fontWeight="bold"
                color="var(--emr-font)"
                fontSize={"20px"}
              >
                {dataAdmin?.groupName}
              </Typography>
              <Typography mt="8px" fontSize={"14px"} color="var(--emr-disable)">
                {dataAdmin?.name}
              </Typography>
            </Box>
          </Box>
          <Box
            onClick={() => setShowReplaceModal(!showReplaceModal)}
            sx={{ cursor: "pointer" }}
            mt="10px"
            ml="20px"
            display={"flex"}
            height="fit-content"
          >
            <ReplacementIcon />
            <Typography mr="5px" fontSize="20px" color="#F05542">
              {"تعویض مسئول گروه"}
            </Typography>
          </Box>
        </Box>
        <Typography color="#000" fontSize="19px" mt="30px">
          {"اطلاعات مسئول گروه"}
        </Typography>
        <Box display="flex">
          <Box width="100%" display="flex" flexWrap="wrap" gap="10px" mt="20px">
            {data?.map((item) => (
              <>
                {item.value && (
                  <Box display="flex" width="300px" alignItems="center">
                    <Typography sx={{ color: "#4E5152", fontSize: "16px" }}>
                      {item.label + " " + ":"}
                    </Typography>
                    <Typography sx={{ color: "#4E5152", fontSize: "16px" }}>
                      {item.value}
                    </Typography>
                  </Box>
                )}
              </>
            ))}
          </Box>
          <Box mt="20px" width="50%">
            <Typography
              width="300px"
              sx={{ color: "#4E5152", fontSize: "16px" }}
            >{`انتساب دانشگاهی/سازمانی:${"گروه بسیج دانشجویی دانشگاه شهید بهشتی"}`}</Typography>
            {dataAdmin?.address && (
              <Typography
                mt="40px"
                width="300px"
                sx={{ color: "#4E5152", fontSize: "16px" }}
              >{`نشانی پایگاه:${dataAdmin?.address}`}</Typography>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
}
